import useExportActionDialog from "@util/hook/useExportActionDialog";
import { useSnackbar } from "notistack";

const useExcelExportFlow = ({validate, getExportParams, exportApi}) => {
	const {showExportConfirmDialog} = useExportActionDialog();
	const { enqueueSnackbar } = useSnackbar();

	// 權限/密碼檢查通過後，才會進到這裡執行匯出 API。
	const handleExportApi = async params => {
		const resp = await exportApi(params);
		// 只顯示有內容的成功字串，避免空字串訊息。
		if (typeof resp === "string" && resp.trim()) {
			enqueueSnackbar(resp, { variant: "success" });
		}
	};

	const handleExcelOnClick = () => {
		if (!validate?.()) return;

		const exportParams = getExportParams?.();
		// 先走共用的權限/密碼確認流程，再呼叫真正匯出。
		showExportConfirmDialog(exportParams, params => handleExportApi(params));
	};

	return {
		onExcelOnClick: handleExcelOnClick,
	};
};

export default useExcelExportFlow;